import * as React from "react";
import type { SVGProps } from "react";

const getTheme = (theme) => {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
const SvgTwoColorTransferOut = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill={getTheme(props["data-theme"])}
      fillRule="evenodd"
      d="M6 4.75c-.69 0-1.25.56-1.25 1.25v12c0 .69.56 1.25 1.25 1.25h9a.75.75 0 0 1 0 1.5H6A2.75 2.75 0 0 1 3.25 18V6A2.75 2.75 0 0 1 6 3.25h9a.75.75 0 0 1 0 1.5H6Z"
      clipRule="evenodd"
    />
    <path
      fill="#F7A600"
      fillRule="evenodd"
      d="M14.52 16.576a.75.75 0 0 1-.096-1.056l3.975-4.77H9a.75.75 0 0 1 0-1.5h11a.75.75 0 0 1 .576 1.23l-5 6a.75.75 0 0 1-1.056.096Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgTwoColorTransferOut;
